import { useMemo, useRef, useState } from 'react';
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../../Common/axios';
import { AppFooter } from '../AppFooter';
import { AppHeader } from '../AppHeader';
import { DateTime, Input, LocationCoordinates, Message, Timezone, Title } from '../../Client/ClientUtil';
import { useLocation, useNavigate } from 'react-router-dom';
import GLOBAL, { handleInput } from '../../Common/Util';
import validator from "validator";
import { validateCity, validateDouble, validateMandatoryName, validateMandatoryValue } from '../../Client/ClientValidate';
import { Spinner, Table } from 'react-bootstrap';

export function OptionsTheoryPage (props) {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState(null);
  const [message, setMessage] = useState('');
  const [data, setData] = useState(null);
  const [spinner, setSpinner] = useState('Loading - Option Theory Page');
  const [optionName, setOptionName] = useState('');
  const [optionDate, setOptionDate] = useState('');
  const [optionTime, setOptionTime] = useState('');
  const [optionTimezone, setOptionTimezone] = useState('5.5');
  const [optionPlace, setOptionPlace] = useState('');
  const [optionLongitude, setOptionLongitude] = useState('');
  const [optionLatitude, setOptionLatitude] = useState('');
  const [optionQuestion, setOptionQuestion] = useState('');
  const [optionCount, setOptionCount] = useState('2');
  const [optionArray, setOptionArray] = useState([]);

  const optionNameReference = useRef();
  const optionDateReference = useRef();
  const optionTimeReference = useRef();
  const optionPlaceReference = useRef();
  const optionLongitudeReference = useRef();
  const optionLatitudeReference = useRef();
  const optionQuestionReference = useRef();
  const optionCountReference = useRef();
  
  const setMethod = { 
    setOptionName, setOptionDate, setOptionTime, setOptionTimezone, setOptionPlace,
    setOptionLongitude, setOptionLatitude, setOptionQuestion, setOptionCount, setMessage };

  const loadData = (data) => {
    setOptionName(data.name);
    setOptionDate(data.date);
    setOptionTime(data.time);
    setOptionTimezone(data.timezone);
    setOptionPlace(data.place);
    setOptionLongitude(data.longitude);
    setOptionLatitude(data.latitude);
    setOptionQuestion(data.question);
    setOptionCount(data.optionsCount);
    setOptionArray(data.options);
  }

  useMemo(() => {
    if(runningId===null||runningId===undefined){
      setOptionCount(2);
      setOptionArray(['','']);
      setSpinner(null);
      return;
    } 
    axiosGetWithHeader("/options/"+runningId,
      (response)=>{
        setData(response.data);
        loadData(response.data);
        setSpinner(null);
      },
      (error)=>{
        setData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );

  }, [runningId]);  

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/home.html', { state:{}, replace: true });
      navigate(0);
    }, 100);
  }

  const handleLocationInput = (name, value) => {
      switch(name) {
        case 'optionLongitude': setOptionLongitude(value); break;
        case 'optionLatitude': setOptionLatitude(value); break;
        default : 
      }
  }

  const handleOptionCountInput = (event, setMethod) => {
    const value = event.target.value;
    handleInput(event,setMethod);
    if(value===null||value===undefined||!validator.isNumeric(value)||value>20) {
      return;
    }
    if(optionArray.length<value) {
      const tempArray = [...optionArray];
      for(var i=optionArray.length;i<value;i++) {
        tempArray[i]="";
      }
      setOptionArray(tempArray);
    } else {
      const tempArray = [];
      for(i=0;i<value;i++) {
        tempArray[i]=optionArray[i];
      }
      setOptionArray(tempArray);
    }
  }
  
  const handleOptionValueInput = (event, val) => {
    const value = event.target.value;
    const tempArray = [...optionArray];
    tempArray[val] = value;
    setOptionArray(tempArray);
  }

  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validateMandatoryName(event, optionNameReference,optionName,"name");
    if(msg==='' && optionDate==="" ) {
        msg="Enter date";
        optionDateReference.current.focus();
        event.preventDefault();
    }
    if(msg==='' && optionTime==="" ) {
      msg="Enter time";
      optionTimeReference.current.focus();
      event.preventDefault();
    }
    if(msg==='') msg = validateCity(event,"place name",optionPlaceReference,optionPlace);
    if(msg==='') msg = validateDouble(event,"latitude",optionLatitudeReference,optionLatitude,-90,90);
    if(msg==='') msg = validateDouble(event,"longitude",optionLongitudeReference,optionLongitude,-180,180);
    if(msg==='') msg = validateMandatoryValue(event, optionQuestionReference,optionQuestion,"question");
    var tempCount = ''+optionCount;
    if(optionCount===null|| optionCount===undefined || !validator.isInt((''+tempCount).trim()) || tempCount.length>2 || tempCount.length<1
      || tempCount.trim().indexOf('-')!==-1 || tempCount.trim().indexOf('+')!==-1
      || tempCount.trim()<=0 || tempCount.trim()>20) {
      msg="Enter valid number. min: 1, max: 20";
      optionCountReference.current.focus();
      event.preventDefault();
    }
    setMessage(msg); 
    if(msg==='') {
      const requestData = {
        runningId:data===null?0:data.runningId,
        name: optionName,
        timezone: optionTimezone,
        date: optionDate,
        time: (optionTime.length===5?optionTime:optionTime.substring(0,5)),
        place: optionPlace,
        longitude: optionLongitude,
        latitude: optionLatitude,
        optionsCount: optionCount,
        question: optionQuestion,
        options:optionArray
      }

      axiosPostWithHeader("/options/save", requestData,
          (response)=>{
            //alert('success');
            setMessage(axiosResponseHandler(response, optionNameReference, ()=>{}, "Option is calculated successfully"));
            if(response.data.code==='200') {
              setData(response.data)
              loadData(response.data);
            }
            GLOBAL.isLoading=false;
          },
          (error)=>{
              setMessage(axiosErrorHandler(optionNameReference,error));
          }
      );

    }
    event.preventDefault();
  }


  return(
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
            </div>    
        </div> 
    {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}

    <form onSubmit={handleSubmit}>
    <div class="row align-items-top m-0 homepageheight overflow-auto">
      <div class="col-sm-1 col-md-1 d-none d-md-block"></div>    

      <div class="col-sm-12 col-md-10 m-0 p-2 bg-white text-black">
        <Title title="Options Theory" urlcallback={handleBack}></Title>
        <div class="row m-0 p-0 w-100 border rounded">
          <div class="col m-0 p-0 justify-content-center">
            <Message msg={message} />
            <div class="row m-0 p-0 w-100">
              <div class="col-sm-12 col-lg-4">
                <Input name="optionName" title="Name" placeholder="Name" reference={optionNameReference} data={optionName} callback={(event)=>handleInput(event,setMethod)} />
                <Timezone name="optionTimezone" data={optionTimezone} callback={(event)=>handleInput(event,setMethod)} />
                <DateTime title1="Date * " title2="Time * " dateplaceholder="Date" timeplaceholder="Time" 
                  datename="optionDate" timename="optionTime" 
                  datereference={optionDateReference} timereference={optionTimeReference} 
                  datevalue={optionDate} timevalue={optionTime} callback={(event)=>handleInput(event,setMethod)} />
                <LocationCoordinates 
                      cityname="optionPlace" citytitle="Place * " cityreference={optionPlaceReference} cityvalue={optionPlace}
                      coordinatesname="location" coordinatestitle="Location (Latitude, Longitude) * "
                      longitudename="optionLongitude" latitudename="optionLatitude" 
                      longitudereference={optionLongitudeReference} latitudereference={optionLatitudeReference} 
                      longitudevalue={optionLongitude} latitudevalue={optionLatitude} 
                      callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
              </div>
              <div class="col-sm-12 col-lg-4">
                <Input name="optionQuestion" title="Question" placeholder="Question" reference={optionQuestionReference} data={optionQuestion} callback={(event)=>handleInput(event,setMethod)} />
                <Input name="optionCount" title="Number of Options" data={optionCount} reference={optionCountReference} callback={(event)=>handleOptionCountInput(event,setMethod)} />
                {optionArray.map((value,index)=>(
                  <Input name={"option_"+index} title={"Option "+(index+1)} placeholder={"Option "+(index+1)} data={value} callback={(event)=>handleOptionValueInput(event,index)}/>
                ))}
              </div>
              <div class="col-sm-12 col-lg-4 text-center align-middle">
                {data===null||data===undefined?<></>:
                <>
                  <h2>Option Choice</h2>
                  <h1 class="display-2 fw-bold">{data.result} {optionArray[data.result-1]===undefined || optionArray[data.result-1]===''?"":(" - "+optionArray[data.result-1])}</h1>
                  <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
                    <thead>
                      <tr class=" m-2 p-2">
                        <th class="bg-transparent">#</th>
                        <th class="bg-transparent">Lord</th>
                        <th class="bg-transparent">Retro</th>
                        <th class="bg-transparent">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class=" m-2 p-2">
                        <td class="bg-transparent text-start">Ascendant</td>
                        <td class="bg-transparent text-start">{data.ascendantLord}</td>
                        <td class="bg-transparent">{data.ascendantRetro===false?"No":"Yes"}</td>
                        <td class="bg-transparent text-end pe-4">{data.ascendantValue}</td>
                      </tr>
                      <tr class=" m-2 p-2">
                        <td class="bg-transparent text-start">Moon Star</td>
                        <td class="bg-transparent text-start">{data.moonStarLord}</td>
                        <td class="bg-transparent">{data.moonStarRetro===false?"No":"Yes"}</td>
                        <td class="bg-transparent text-end pe-4">{data.moonStarValue}</td>
                      </tr>
                      <tr class=" m-2 p-2">
                        <td class="bg-transparent text-start">Moon Sign</td>
                        <td class="bg-transparent text-start">{data.moonSignLord}</td>
                        <td class="bg-transparent">{data.moonSignRetro===false?"No":"Yes"}</td>
                        <td class="bg-transparent text-end pe-4">{data.moonSignValue}</td>
                      </tr>
                      <tr class=" m-2 p-2">
                        <td class="bg-transparent text-start">Day</td>
                        <td class="bg-transparent text-start">{data.dayLord}</td>
                        <td class="bg-transparent">{data.dayRetro===false?"No":"Yes"}</td>
                        <td class="bg-transparent text-end pe-4">{data.dayValue}</td>
                      </tr>
                      <tr class=" m-2 p-2">
                        <th class="bg-transparent text-start">Total</th>
                        <td class="bg-transparent text-start"></td>
                        <td class="bg-transparent"></td>
                        <th class="bg-transparent text-end pe-4">{data.total}</th>
                      </tr>
                    </tbody>
                  </Table>
                </>
                }                
              </div>
            </div>

            <div class="card-body d-flex justify-content-center p-0 ">
              <div class="w-50">
                <div class="mb-2 d-grid gap-2 d-flex justify-content-center ">
                  <button type="submit" class="btn btn-primary">Calculate</button>
                </div>
              </div>
            </div>  

          </div>
        </div>
      </div>

      <div class="col-sm-1 col-md-1 d-none d-md-block"></div>    
    </div>
    </form>

    <div class="m-0 p-0 row noprint">
      <div class="m-0 p-0 col-sm-12 col-md-12">
        <AppFooter/>
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>    
    </div> 

    </>
  );

}
